import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "fury-add-edit-time-schedule-modal",
  templateUrl: "./add-edit-time-schedule-modal.component.html",
  styleUrls: ["./add-edit-time-schedule-modal.component.scss"],
})
export class AddEditTimeScheduleModalComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  timeScheduleForm = new FormGroup({
    status: new FormControl("", [Validators.required]),
    startTime: new FormControl("", [Validators.required]),
    endTime: new FormControl("", [Validators.required]),
  });
  scheduleTimes = [
    "0:00",
    "0:30",
    "1:00",
    "1:30",
    "2:00",
    "2:30",
    "3:00",
    "3:30",
    "4:00",
    "4:30",
    "5:00",
    "5:30",
    "6:00",
    "6:30",
    "7:00",
    "7:30",
    "8:00",
    "8:30",
    "9:00",
    "9:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
    "23:00",
    "23:30",
    "23:59",
  ];
  status = ["Available", "Busy", "Leave"];
  constructor(
    public dialogRef: MatDialogRef<AddEditTimeScheduleModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { isAddType: boolean; dayName: string, selectedCellValue: any }
  ) {}

  ngOnInit(): void {
    if(!this.data.isAddType) {
     this.timeScheduleForm.patchValue({
      status: "Available",
      startTime: this.data.selectedCellValue?.startTime,
      endTime: this.data.selectedCellValue?.endTime
     });
    } else {
      this.timeScheduleForm.patchValue({
        startTime: this.data.selectedCellValue?.startTime,
       });
    }
    this.timeScheduleForm
      .get("startTime")
      ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.validateEndTime();
      });

    this.timeScheduleForm
      .get("endTime")
      ?.valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.validateEndTime();
      });
  }
  close(res?: any) {
    this.dialogRef.close(res);
  }
  validateEndTime() {
    const startTime = this.timeScheduleForm.get("startTime")?.value;
    const endTime = this.timeScheduleForm.get("endTime")?.value;

    if (
      startTime &&
      endTime &&
      this.timeToMinutes(startTime) >= this.timeToMinutes(endTime)
    ) {
      this.timeScheduleForm
        .get("endTime")
        ?.setErrors({
          endTimeError: "End time must be greater than start time",
        });
    } else {
      this.timeScheduleForm.get("endTime")?.setErrors(null);
    }
  }
  timeToMinutes(time: string): number {
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }
  submit(){
    if(this.timeScheduleForm.valid) {
      let value: any = this.timeScheduleForm.value;
      value.dayName = this.data.dayName;
      value.isAddType = this.data.isAddType;
      value.previousScheduleData = this.data.selectedCellValue;
      this.close(value);
    } else {
      this.timeScheduleForm.markAllAsTouched();
    }
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
